/// <amd-module name="Search/Shared/Components/NotificationArea" />
export * from "./NotificationArea/index";
